module.exports = "<div class=\"status-message-container\" ng-show=\"loadingIcon.show\">\r\n    <img src=\"" + require("../../../img/loading.svg") + "\" ng-src=\"{{loadingIcon.img}}\" class=\"status-image\">\r\n    <div class=\"status-message\">{{loadingIcon.label | translate}}</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/core-components/loading-icon/template.html
// module id = 2868
// module chunks = 0